// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/style-component/components/cardAvatarStyle.js";
// @material-ui/icons
// core components
import { estilos } from "assets/jss/style-component/components/estiloComponente.js";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(styles);

export default function CardAvatar(props) {
  const { children } = props;
  const cardClasses = estilos(useStyles(), props, "avatar");

  return <div className={cardClasses}>{children}</div>;
}

CardAvatar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  profile: PropTypes.bool,
  plain: PropTypes.bool
};
